module.exports = __webpack_public_path__ + "static/media/Gym.4b33a554.svg";